function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0V10.9194H3.07692V14L6.98558 10.9194H16V0H0ZM1.23077 1.21327H14.7692V9.70616H6.55289L4.30769 11.4763V9.70616H1.23077V1.21327ZM4.30769 4.24645C3.6274 4.24645 3.07692 4.7891 3.07692 5.45972C3.07692 6.13033 3.6274 6.67299 4.30769 6.67299C4.98798 6.67299 5.53846 6.13033 5.53846 5.45972C5.53846 4.7891 4.98798 4.24645 4.30769 4.24645ZM8 4.24645C7.31971 4.24645 6.76923 4.7891 6.76923 5.45972C6.76923 6.13033 7.31971 6.67299 8 6.67299C8.68029 6.67299 9.23077 6.13033 9.23077 5.45972C9.23077 4.7891 8.68029 4.24645 8 4.24645ZM11.6923 4.24645C11.012 4.24645 10.4615 4.7891 10.4615 5.45972C10.4615 6.13033 11.012 6.67299 11.6923 6.67299C12.3726 6.67299 12.9231 6.13033 12.9231 5.45972C12.9231 4.7891 12.3726 4.24645 11.6923 4.24645Z",
  fill: "#141414"
});

function SvgIconMessageSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageSquare);
export default __webpack_public_path__ + "static/media/iconMessageSquare.c0b14472cc2c2e5443e4cc160adba8b1.svg";
export { ForwardRef as ReactComponent };